import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Injector,
} from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ConnectionService } from '@app/shared/services/connection.service';
import { LayoutService } from '@app/shared/services/layout.service';
import { MediaService } from '@app/shared/services/Media.service';
import { SavedViewsService } from '@app/shared/services/saved-views.service';
import { NzDrawerService } from 'ng-zorro-antd/drawer';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalService } from 'ng-zorro-antd/modal';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { Subscription } from 'rxjs';
import { AttributeService } from './services/attribute-service.service';
import { CommonService } from './services/common.service';
import { ProductService } from './services/product.service';
import { ProductCatalogService } from '@app/shared/services/product-catalog.service';
import { ListColumnsService } from './services/list-columns.service';
import { TranslateService } from '@ngx-translate/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-base-product',
  template: '',
  styles: [],
})
export class BaseProductComponent {
  subscriptions: Subscription[] = [];
  breadCrumbItems: string[] = [];
  protected layoutService: LayoutService;
  protected router: Router;
  protected message: NzMessageService;
  protected route: ActivatedRoute;
  protected fb: FormBuilder;
  protected connectionService: ConnectionService;
  protected notification: NzNotificationService;
  protected productService: ProductService;
  public commonService: CommonService;
  protected drawerService: NzDrawerService;
  protected mediaService: MediaService;
  protected savedViewsService: SavedViewsService;
  protected modalService: NzModalService;
  protected attributesService: AttributeService;

  protected productCatalog:ProductCatalogService;
  protected translate: TranslateService;
  protected sanitizer: DomSanitizer;
  constructor(injector: Injector) {
    this.modalService = injector.get(NzModalService);
    this.attributesService = injector.get(AttributeService);
    this.savedViewsService = injector.get(SavedViewsService);
    this.mediaService = injector.get(MediaService);
    this.productService = injector.get(ProductService);
    this.commonService = injector.get(CommonService);
    this.layoutService = injector.get(LayoutService);
    this.router = injector.get(Router);
    this.message = injector.get(NzMessageService);
    this.route = injector.get(ActivatedRoute);
    this.fb = injector.get(FormBuilder);
    this.connectionService = injector.get(ConnectionService);
    this.notification = injector.get(NzNotificationService);
    this.drawerService = injector.get(NzDrawerService);

    this.productCatalog=injector.get(ProductCatalogService);
    this.sanitizer=injector.get(DomSanitizer);

  }
  ngOnDestroy(): void {
    this.subscriptions.forEach((x) => x.unsubscribe());
  }
  submit() {
    this.mediaService.submitMedia$.emit();
  }
}
